import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
// components
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownListModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { UploadModule } from '@progress/kendo-angular-upload';
import { SalesWebOrdersLibraryModule } from '@tt-chvac/order';
import { SharedCoreModule } from '@tt-chvac/core';
import { SharedCoreSaleswebModule } from '@tt-chvac/core-sales-web';
import { environment } from '../../../../environments/environment';
import { JobsServicesService } from '../../../modules/jobs-list-master/services/jobs-services.service';
import { UserService } from '../../../modules/jobs-list-master/services/user.service';
import { ExitComponent } from '../../components/exit/exit.component';
import { UserPreferencesComponent } from '../../components/user-preferences/user-preferences.component';
import { KeyTeamMembersComponent } from './../../components/key-team-members/key-team-members.component';
import { TableauDashboardComponent } from "../../../modules/tableau/tableau-dashboard/tableau-dashboard.component";

export function httpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    DropDownListModule,
    ReactiveFormsModule,
    DropDownsModule,
    GridModule,
    TooltipModule,
    TreeViewModule,
    FormsModule,
    DialogsModule,
    ButtonsModule,
    DatePickerModule,
    InputsModule,
    LayoutModule,
    PopupModule,
    UploadModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedCoreModule,
    SharedCoreSaleswebModule,
    IndicatorsModule,
    SalesWebOrdersLibraryModule.forRoot(environment)
  ],
  declarations: [ExitComponent, UserPreferencesComponent, KeyTeamMembersComponent, TableauDashboardComponent],
  exports: [ReactiveFormsModule, TooltipModule, SharedCoreModule,
    KeyTeamMembersComponent, SharedCoreSaleswebModule,
  ],
  providers: [JobsServicesService, UserService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule { }
